import { Component, OnInit } from '@angular/core';
import { ActivationPassportService } from './activation-passport.service';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';

//jquery var
declare var $: any;

@Component({
  selector: 'app-activation-passport',
  templateUrl: './activation-passport.component.html',
  styleUrls: ['./activation-passport.component.scss']
})
export class ActivationPassportComponent implements OnInit {

  //Declaracion de variables de clase
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isCodeSent = true;
  isModalReload = false;
  documentValue = "";
  numericPattern = "";
  alphanumericPattern = "";
  emailPattern = "";
  datePattern = "";
  phonePattern = "";
  passaportForm: FormGroup;
  isFileLoadPortForm = false;
  activeTab = 1;
  isNextStepReady = false;
  isBackDisabled = true;
  ispstep1Checked = false;
  ispstep2Checked = false;
  isLoading = false;
  isDownloading = false;
  cityProvinceList = [];
  inputNamesText = "";
  inputLastNamesText = "";
  inputBornDateText = "";
  labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');
  isFinishedProcess = false;
  maxDateToInitDate = new Date();
  optionsFormatDate = { year: 'numeric', month: '2-digit', day: '2-digit' };

  //data objects
  fileLoadPortFormData = null;

  //file input
  ACCEPT_FILES = constants.ACCEPT_FILES;

  constructor(public LANG: CommonUtilitiesService, private activationPassportService: ActivationPassportService, private _router: Router, private formbuilder: FormBuilder) { }

  /**
  * Description: Método que inicializa las variables y validaciones del formulario
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  ngOnInit() {
    //validaciones de formulario
    this.numericPattern = constants.REGEX_NUMERIC_PATTERN;
    this.phonePattern = constants.REGEX_PHONE_PATTERN;
    this.alphanumericPattern = constants.REGEX_ALPHANUMERIC_PATTERN;
    this.emailPattern = constants.REGEX_EMAIL_PATTERN;
    this.passaportForm = this.formbuilder.group({
      inputNames: ['', [Validators.required, Validators.pattern(this.alphanumericPattern)]],
      inputCity: ['', [Validators.required]],
      inputLastNames: ['', [Validators.required, Validators.pattern(this.alphanumericPattern)]],
      inputFullAddress: ['', [Validators.required]],
      inputBornDate: ['', [Validators.required]],
      inputAditionalNum: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputEmail: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      inputICC: ['', [Validators.required, Validators.pattern(this.alphanumericPattern)]],
      inputIMEI: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      pinputFilePortForm: ['', [Validators.required]]
    });

    //se asignan los valores de los tooltips
    this.setTooltips();
    this.getCityProvinceList();
  }

  /**
   * Description: Método que inicializa todos los popovers o tooltips del formulario
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  setTooltips() {
    let iccTooltipText = this.LANG.getLangText('PORTABILITY_TOOLTIP_ICC');
    $('#ptooltipICC').popover({
      html: true,
      content: '<div style="text-align: center;" class="test">' + iccTooltipText + '<br><img src="./assets/chip.png"></div>'
    });

    $('#ptooltipIMEI').popover({
      html: true,
      content: this.LANG.getLangText('PORTABILITY_TOOLTIP_IMEI')
    });

    $('#ptooltipAddNum').popover({
      html: true,
      content: this.LANG.getLangText('PORTABILITY_TOOLTIP_ADDNUM')
    });
  }

  /**
    * Description: Método que obtiene la lista de ciudades y provincias
    * Autor: Diego Diaz
    * @param N/A
    * @return N/A
    */
  getCityProvinceList() {
    this.activationPassportService.getCityProvinceList().subscribe((valData => {
      this.cityProvinceList = valData["obj"];
    }),
      (err) => {
        this.cityProvinceList = [];
      });

  }

  /**
   * Description: Método que cambia la pantalla para continuar con el proceso de portabilidad
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  nextStep() {

    if (this.activeTab == 1) {
      // Validacion de campos paso 1
      if (this.passaportForm.get('inputIMEI').invalid
        || this.passaportForm.get('inputICC').invalid) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
        this.isShowModal = true;
        return;
      }
      this.isLoading = true;
      this.activationPassportService.validateICC(this.passaportForm.get('inputICC').value).subscribe((valData => {

        if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE || valData["obj"].valid != true) {
          this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
          this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_VALIDATION_ICC_ERROR');
          this.isShowModal = true;
          this.isLoading = false;
          return false;
        }

        this.activationPassportService.validateIMEI(this.passaportForm.get('inputIMEI').value).subscribe((data => {
          this.isLoading = false;
          if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE || data['obj'].valid != true) {
            this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
            this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_ERROR_IMEI');
            this.isShowModal = true;
            return false;
          }

          //seleeciona como activa la pestaña 2
          this.activeTab = 2;
          //cambia a la pestaña 2
          this.changeTab(2);
          //habilita boton de regresar
          this.isBackDisabled = false;
          //muestra el icono check del paso 1
          this.ispstep1Checked = true;
        }),
          (err) => {
            this.isLoading = false;
            this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
            this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
            this.isShowModal = true;
          });

      }),
        (err) => {
          this.isLoading = false;
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;
        });

    } else if (this.activeTab == 2) {
      // Validacion de campos paso 2
      if (this.passaportForm.get('inputIMEI').invalid
        || this.passaportForm.get('inputNames').invalid
        || this.passaportForm.get('inputLastNames').invalid
        || this.passaportForm.get('inputBornDate').invalid
        || this.passaportForm.get('inputEmail').invalid
        || this.passaportForm.get('inputCity').invalid
        || this.passaportForm.get('inputAditionalNum').invalid
        || this.passaportForm.get('inputFullAddress').invalid) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
        this.isShowModal = true;
        return;
      }

      if (!this.LANG.isValidPhoneZero(this.passaportForm.get('inputAditionalNum').value)) {
        //si no tiene el prefijo 0 no puede seguir
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PHONE_VALIDATOR_ERROR_ZERO');
        this.isShowModal = true;
        return false;
      }

      let bornDateValid = this.passaportForm.get('inputBornDate').value;
      if (new Date(bornDateValid) > new Date()) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('CALL_LOG_DETAIL_LABEL_END_DATE_WRONG');
        this.isShowModal = true;
        return false;
      }

      let bornDateValidMaxAge = this.passaportForm.get('inputBornDate').value;
      let currentDate = new Date();
      let month = currentDate.getUTCMonth() + 1; //months from 1-12
      let day = currentDate.getUTCDate();
      let year = currentDate.getUTCFullYear();
      var minAgeDate = new Date(year - constants.YEAR_MAX_LIMIT, month, day);

      if (new Date(bornDateValidMaxAge) > minAgeDate) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('ACTIVATION_PASSPORT_AGE_LIMIT');
        this.isShowModal = true;
        return false;
      }

      //activa una nueva tab 3
      this.changeTab(3);
      //selecciona la pestaña 3 como actual
      this.activeTab = 3;
      //deja el codigo sms como valido
      this.isCodeSent = true;
      //activa el boton de regresar
      this.isBackDisabled = false;
      //muestra el icono de checkeado del paso 2
      this.ispstep2Checked = true;
      //cambia el label del boton de continuar por finalizar
      this.labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');

    } else if (this.activeTab == 3) {
      //realiza proceso de request de portabilidad
      this.endStep();
    }

  }

  /**
   * Description: Método que cambia la pantalla para volver con el paso 1 o 2 del proceso de portabilidad
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  backStep() {

    if (this.activeTab <= 2) {
      this.isBackDisabled = true;
    }

    if (this.activeTab > 1) {
      this.changeTab((this.activeTab - 1));
      this.activeTab = (this.activeTab - 1);
      this.labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');
    }
  }

  /**
   * Description: Método que cambia de tab o paso en el wizard
   * Autor: Diego Diaz
   * @param tab paso que se desea mostrar
   * @return N/A
   */
  changeTab(tab) {

    this.scrollToForm();
    var aStep = document.getElementById('pstep' + tab + '-tab');
    (<any>aStep).href = "#pstep" + tab;
    aStep.click();
  }

  /**
   * @description Metodo que hace scroll al inicio del formulario
   * @author eciro
   */
  scrollToForm() {
    $('html,body').animate({
      scrollTop: $("#link-steps-activation-menu").offset().top
    }, 'slow');
  }

  /**
   * Description: Método que envía el codigo de validación por SMS
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  sendValidationCode() {

    // Validacion de campos paso 1
    if (this.passaportForm.get('inputNumber').invalid) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_INVALID_PHONE_VALIDATION');
      this.isShowModal = true;
      return;
    }

    //procesar envio sms validacion
    this.isLoading = true;
    this.activationPassportService.sendSMSCode(this.passaportForm.get('inputNumber').value).subscribe((data => {
      this.isLoading = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_ERORO_SEND_SMS');
        this.isShowModal = true;
        return false;
      }

      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_INFO');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_SEND_CODE');
      this.isCodeSent = false;
      this.isShowModal = true;
    }),
      (err) => {
        this.isLoading = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
   * Description: Método que envía el codigo de validación por SMS
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    }
  }

  /**
   * Description: Método que abre la ventana de carga de archivos adjuntos
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  loadHiddenFilePort(id: string) {
    $("#" + id).click();
  }

  /**
   * Description: Método que valida si se ha subido un archivo y lo marca como OK
   * Autor: Diego Diaz
   * @param $event
   * @return N/A
   */
  setFileOkFlagPort($event) {
    let id = $event.target.id;
    let filename = $('#' + id).val();

    /**
     * @AddBy Julian Ciro
     * Se añade validación que verifica la extensión del archivo
     */
    const isFileValid = constants.EXTENSION_FILE_AVAILABLE.includes(filename.substring(filename.lastIndexOf('.')).toUpperCase());
    if (!isFileValid) {
      this.modalTitle = this.LANG.getLangText('EXTENSION_FILE_INVALID_TITTLE');
      this.modalContent = this.LANG.getLangText('EXTENSION_FILE_INVALID');
      this.isShowModal = true;
      $('#' + id).val(''); //ID del input file hiddden
      $('#' + id + 'Face').val(''); //ID del input que muestra la ruta del archivo seleccionado
      return;
    }

    $('#' + id + "Face").val(filename);
    //carga el archivo en base64
    this.getBase64($event.target, id);
    if (id == 'pinputFilePortForm') {
      this.isFileLoadPortForm = true;
    }
  }

  /**
   * Description: Método que envia la solicitud de procesamiento de portabilidad al backend
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  endStep() {
    // Validacion de campos generales y de archivos
    if (this.passaportForm.invalid || !this.validateAttachedFiles()) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      return;
    }

    var fileList = [];
    if (this.fileLoadPortFormData != null) {
      fileList.push({ "name": $('#pinputFilePortForm').prop('files')[0].name, "attached": this.fileLoadPortFormData.split(',')[1] });
    }

    /**
     * @ModifiedBy Julian Ciro
     * Se cambia la forma de formatear la fecha de nacimiento
     * Se elimina el metodo formatDate
     * Se agrega replace en la conversión de fechas, debido a que en IE(solo en este) se agregan símbolos al enviarlos en el json
     */
    let jsonData = {
      "imei": this.passaportForm.get('inputIMEI').value,
      "icc": this.passaportForm.get('inputICC').value,
      "type": constants.TYPE_PAS,
      "givenName": this.passaportForm.get('inputNames').value,
      "familyName": this.passaportForm.get('inputLastNames').value,
      "birthDate": this.passaportForm.get('inputBornDate').value.toLocaleDateString('en-GB', this.optionsFormatDate).replace(/[^ -~]/g, ''),
      "city": this.passaportForm.get('inputCity').value,
      "email": this.passaportForm.get('inputEmail').value,
      "msisdnNotification": this.passaportForm.get('inputAditionalNum').value,
      "address": this.passaportForm.get('inputFullAddress').value,
      "attached": fileList
    };

    this.isLoading = true;
    this.activationPassportService.sendPortabilityRequest(jsonData).subscribe((data => {
      this.isLoading = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_ERROR_SENDING_REQUEST');
        this.isShowModal = true;
        return false;
      }

      this.scrollToForm();
      this.isFinishedProcess = true;
    }),
      (err) => {
        this.isLoading = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
   * Description: Método que valida que existan los archivos adjuntos
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  validateAttachedFiles() {
    var isValidFileLoad = false;
    var filePortForm = $("#pinputFilePortForm")[0].files;
    if (filePortForm.length != 0) {
      isValidFileLoad = true;
    }
    return isValidFileLoad;
  }

  /**
   * Description: Método que permite la descarga del formulario de portabilidad
   * Autor: Diego Diaz
   * @param N/A
   * @return Formulario de portabilidad para descarga
   */
  downloadFormFile() {
    //procesar descarga formato
    this.isDownloading = true;
    this.activationPassportService.getDocumentFormat().subscribe((data => {
      this.isDownloading = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return false;
      }
      var fileToDownload = data["obj"][0].file;
      var url = constants.BASE64_PDF_FILE + fileToDownload;
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = url;
      a.download = constants.PORTABILITY_DOWNLOAD_FILE_NAME;
      a.click();
      window.URL.revokeObjectURL(url);

    }),
      (err) => {
        this.isDownloading = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
  * Description: Método que carga el archivo seleccionado
  * Autor: Diego Diaz
  * @param inputValue campo tipo file
  * @param id identificador
  * @return N/A
  */
  getBase64(inputValue, id) {
    var file: File = inputValue.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    var _self = this;
    reader.onload = function () {
      if (id == 'pinputFilePortForm') {
        _self.fileLoadPortFormData = reader.result;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

}
